import {COLORS} from 'core/styles';
import styled from 'styled-components';

export const DateContainer = styled.div`
    color: ${COLORS.grayFont};
    font-weight: 500;
    font-size: 11px;
    ${(props) => (props.$css ? props.$css : '')}
`;
